import HeadNav from "../../components/HeadNav";
import {cutPhone, cutPhone1, showTotalData, fmDate, encrypt, LZStringCompress} from "../../tools";
import ListEmpty from "../../components/ListEmpty";
import {fetchPost,fetchGet} from "../../tools/https"
import {BigNumberStr,BigNumberMul,BigNumberDiv,BigNumberAdd,BigNumberSub} from "../../tools/indexFun";
import localStore from '../../tools/localstorage'
export default {
  name: "Gpt",
  components: {
    HeadNav,
    ListEmpty
  },
  data() {
    return {
      messages: localStore.fetch('messages'),
      value: null,
    }

  },
  created() {
  },
  methods: {
    BigNumberStr(num1,num2,col){
      return BigNumberStr(num1,num2,col);
    },
    async getDepositLog() {
      // fetchGet('models',{}).then((data)=>{
      //   console.log('data',data)
      // })
    },
    async refresh() {
      this.getDepositLog();
    },
    async onSearch(){
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
        this.messages.push({"role": "user", "content": this.value})
        // this.$store.commit('setState', {
        //   messages: this.messages
        // })
        localStore.save('messages',this.messages)
      let obj = {
        "model": "gpt-3.5-turbo",
        "messages": this.messages
      }
      fetchPost('chat/completions',obj).then((data)=>{
          // console.log('data',data)
          let message = data?.choices[0]?.message?.content;
          this.messages.push({"role": "assistant", "content": message})
          // this.$store.commit('setState', {
          //   messages: this.messages
          // })
          localStore.save('messages',this.messages)
        this.$toast.clear();
      }).catch((err)=>{
        this.$toast.clear();
      })
      this.value=null
    },
  },
  mounted() {
    this.refresh();
  }
}
